(function () {
    'use strict';

    angular.module('AngularAdmin')

        .controller('ObjectConfigurationCtrl', ['$scope', '$modal', 'PermissionSvc', function ($scope, $modal, PermissionSvc) {

            // Controller which manages objects
            $scope.saveComponent = function () {
                var savePromise;
                if ($scope.editedObject.id) {
                    // Edit
                    savePromise = $scope.ObjectService.update($scope.editedObject, $scope.plant);
                } else {
                    // Create
                    savePromise = $scope.ObjectService.create($scope.editedObject, $scope.plant);
                }
                savePromise.success(handleSuccess).error(handleErrors);

                function handleSuccess(data) {
                    $scope.disableInput = false;
                    $scope.cancelEditing();
                    // Re-fetch data
                    $scope.fetchData();
                    $scope.error = {}; // reset the error object
                }

                function handleErrors(message) {
                    $scope.error = message;
                    $scope.disableInput = false;
                }
            };

            $scope.editObject = function (object) {
                $scope.mode = 'edit';

                if (object) {
                    // Edit existing
                    $scope.editedObject = $scope.getEditableObject(object);
                } else {
                    // Create new
                    $scope.editedObject = $scope.createEmptyObject();

                    // Add two empty components
                    // Should we take this out?
                    $scope.addComponent();
                    // $scope.addComponent();
                }
                $scope.originalObject = angular.copy($scope.editedObject);
            };

            $scope.cancelEditing = function () {
                $scope.mode = 'default';
                $scope.editedObject = null;
                $scope.originalObject = null;
                $scope.error = {}; // reset the error object
            };


            // Helpers
            $scope.init = function () {
                // Assertions
                if (!$scope.ObjectService) {
                    throw "Set ObjectService";
                }
                // Load data
                $scope.fetchData();

                PermissionSvc.getPlantPermissions($scope.plant).then(function (permissionsObject) {
                    $scope.permissions = permissionsObject.permissions;
                });
            };

            $scope.createEmptyObject = $scope.fetchData = function () {
                throw "Sub-controller must implement"
            };

            // Init
            $scope.plant = $scope.$root.plant;
            $scope.mode = 'default'; // 'edit'
            $scope.editedObject = {};
            $scope.disableInput = false; // loading state
            $scope.ObjectService = null;

        }])

        .controller('ObjectWithChildListConfigurationCtrl', ['$scope', '$modal', '$controller', function ($scope, $modal, $controller) {
            // Controller which manages objects which contain components, eg MixDesigns and Production Modes
            // Inherit from parent controller
            $controller('ObjectConfigurationCtrl', {$scope: $scope});

            //
            // Scope fn's
            //

            // Actions
            $scope.selectObject = function (object_id) {
                $scope.selectedObject = object_id;
            };

            $scope.getEditableObject = function (object) {
                return angular.copy(object);
            };

            $scope.openAddMaterialDialog = function ($event, object, config) {
                // Add material to component
                config = config || {};
                config.callback = addMaterialCb;
                config.output_material = false;

                var modalInstance = $modal.open({
                    templateUrl: '/static/partials/edit_material.html',
                    controller: 'MaterialModalCtrl',
                    resolve: {
                        config: function () {
                            return config;
                        }
                    }
                });

                function addMaterialCb(data) {
                    // Called when the material is added
                    object.material = data.id;
                    $scope.materials.push(data);
                }
            };

            $scope.sumOfComponents = function () {
                var total = 0;
                $scope.editedObject.components.forEach(function (component) {
                    total += parseFloat(component.proportion) || 0;
                });
                return total;
            };

            $scope.addComponent = function () {
                var new_component = $scope.createEmptyComponent();
                $scope.editedObject.components.push(new_component);
            };

            $scope.deleteComponent = function (index, component) {
                var index = $scope.editedObject.components.indexOf(component);
                if (index > -1) {
                    $scope.editedObject.components.splice(index, 1);
                }
            };
            $scope.createEmptyComponent = function () {
                throw "Sub-controller must implement"
            };

            $scope.checkSupplierName = function (name) {
                return name ? " (" + name + ")" : ""
            };

            $scope.isOutputMaterial = function (item) {
                if ($scope.editedObject.id > 0) {
                    if (item.id == $scope.originalObject.output_material) {
                        return true;
                    }
                }
                return !!item.is_output_material && !(item.mix_designs.length > 0);
            };

            // Controller, expose scope functions
            this.selectObject = $scope.selectObject;

            // Initialization variables
            $scope.selectedObject = null; // TODO better naming between selected and edited object


        }])

        .directive('pdMixDesignConfigurator', ['$rootScope', '$modal', 'MixDesignSvc', 'MaterialSvc', 'ModalSvc', function ($rootScope, $modal, MixDesignSvc, MaterialSvc, ModalSvc) {
            return {
                restrict: "E",
                scope: {},
                replace: true,
                templateUrl: '/static/partials/configuration/mix_designs.html',
                controller: ['$scope', '$controller', function ($scope, $controller) {
                    // Inherit from parent controller
                    $controller('ObjectWithChildListConfigurationCtrl', {$scope: $scope});

                    $scope.openAddMaterialAsOutputDialog = function ($event, config) {
                        config = config || {};

                        config.callback = addMaterialCb;
                        config.output_material = true;

                        var modalInstance = $modal.open({
                            templateUrl: '/static/partials/edit_material.html',
                            controller: 'MaterialModalCtrl',
                            resolve: {
                                config: function () {
                                    return config;
                                }
                            }
                        });

                        function addMaterialCb(data) {
                            // Called when the material is added
                            $scope.editedObject.output_material = data.id;
                            $scope.materials.push(data);
                        }
                    };

                    $scope.createEmptyComponent = function () {
                        return {
                            material: null,
                            mix_design: null, // todo, prefil id?
                            proportion: 0
                        };
                    };

                    $scope.createEmptyObject = function () {
                        return {
                            components: [],
                            expiration_date: moment().format($scope.$root.dateFormat.moment), // TODO, today
                            name: "",
                            output_material: null,
                            plant: $scope.plant, // todo plant id
                            specification_basis: "",
                            verified: false
                        };
                    };

                    $scope.deleteObject = function ($event, object_id) {
                        $event.stopPropagation();

                        ModalSvc.mixDesignDeleteModal.open({
                            mix_design_id: object_id,
                            callback: function (data) {
                                $scope.fetchData();
                                $scope.selectObject(null);
                                $scope.mode = 'default';
                            }
                        });
                    };

                    //
                    // Load Data
                    //
                    $scope.fetchData = function () {
                        MixDesignSvc.loadAll($rootScope.plant).success(function (data) {
                            $scope.mix_designs = data;
                        });

                        MaterialSvc.list($rootScope.plant).success(function (data) {
                            $scope.materials = data;
                            $scope.materialsById = MaterialSvc.listToIdMap(data);
                        });
                    };

                    //
                    // Initial Data
                    //
                    $scope.popoverTitle = "Input materials";
                    $scope.ObjectService = MixDesignSvc;
                    $scope.mix_designs = [];
                    $scope.materials = [];
                    $scope.materialsById = {};
                    $scope.init();
                }],
                // replace: true,
                link: function ($scope, $element, $attr) {

                }
            };
        }])

        .directive('pdProductionModeConfigurator', ['$rootScope', 'ProductionModeSvc', 'MaterialSvc', 'ModalSvc', function ($rootScope, ProductionModeSvc, MaterialSvc, ModalSvc) {
            return {
                restrict: "E",
                scope: {},
                replace: true,
                templateUrl: '/static/partials/configuration/production_modes.html',
                controller: ['$scope', '$controller', function ($scope, $controller) {
                    // Inherit from parent controller
                    $controller('ObjectWithChildListConfigurationCtrl', {$scope: $scope});

                    // TODO implement methods
                    $scope.createEmptyComponent = function () {
                        return {
                            material: null,
                            mix_design: null, // todo, prefil id?
                            proportion: 0
                        };
                    };

                    $scope.createEmptyObject = function () {
                        return {
                            name: "",
                            default_hourly_rate: 100,
                            components: [],
                            plant: $scope.plant // todo plant id
                        };
                    };

                    $scope.deleteObject = function ($event, object_id) {
                        $event.stopPropagation();

                        ProductionModeSvc.can_delete(object_id, $scope.$root.plant).success(function () {
                            ModalSvc.productionModeDeleteModal.open({
                                production_mode_id: object_id,
                                callback: function (data) {
                                    $scope.fetchData();
                                    $scope.selectObject(null);
                                    $scope.mode = 'default';
                                }
                            });
                        }).error(function (data) {
                            ModalSvc.alert.open({message: data.detail, title: "Cannot delete the production mode."});
                        });


                    };


                    //
                    // Load Data
                    //
                    $scope.fetchData = function () {
                        $scope.ObjectService.loadAll($rootScope.plant).success(function (data) {
                            $scope.production_modes = data;
                        });

                        MaterialSvc.list($scope.plant).success(function (data) {
                            $scope.materials = data;
                            $scope.materialsById = MaterialSvc.listToIdMap(data);
                        });
                    };

                    //
                    // Initial Data
                    //

                    $scope.ObjectService = ProductionModeSvc;
                    $scope.production_modes = [];
                    $scope.materials = [];
                    $scope.materialsById = {};
                    $scope.init();

                }],
                // replace: true,
                link: function ($scope, $element, $attr) {

                }
            };
        }])

        .directive('pdMaterialConfigurator', ['MaterialSvc', 'SupplierSvc', 'ModalSvc', function (MaterialSvc, SupplierSvc, ModalSvc) {
            return {
                restrict: "E",
                scope: {},
                replace: true,
                templateUrl: '/static/partials/configuration/materials.html',
                controller: ['$scope', '$controller', function ($scope, $controller) {
                    // Inherit from parent controller
                    $controller('ObjectConfigurationCtrl', {$scope: $scope});

                    $scope.getEditableObject = function (object) {
                        return MaterialSvc.get(object.id, $scope.plant).success(function (data) {
                            $scope.editedObject = data;
                        });
                    };

                    $scope.deleteObject = function ($event, object_id) {
                        $event.stopPropagation();

                        MaterialSvc.can_delete(object_id, $scope.$root.plant).success(function () {
                            ModalSvc.materialDeleteModal.open({
                                material_id: object_id,
                                callback: function (data) {
                                    $scope.fetchData();
                                    $scope.editedObject = null;
                                    $scope.mode = 'default';
                                }
                            });
                        }).error(function (data) {
                            ModalSvc.alert.open({message: data.detail, title: "Cannot delete the material."});
                        });
                    };

                    //
                    // Load Data
                    //
                    $scope.fetchData = function () {
                        MaterialSvc.list($scope.plant).success(function (data) {
                            $scope.materials = data;
                            $scope.materialsById = MaterialSvc.listToIdMap(data);
                        });

                        SupplierSvc.list().success(function (data) {
                            $scope.suppliers = data;
                        });
                    };

                    //
                    // Initial Data
                    //
                    $scope.ObjectService = MaterialSvc;
                    $scope.suppliers = [];
                    $scope.materials = [];
                    $scope.materialsById = {};
                    $scope.init();

                }],
                // replace: true,
                link: function ($scope, $element, $attr) {

                }
            };
        }])

        .directive('pdMixDesignPopover', ['$rootScope', 'MixDesignSvc', 'MaterialSvc', function ($rootScope, MixDesignSvc, MaterialSvc) {
            return {
                // require: "^pdMixDesignConfigurator",
                restrict: "E",
                templateUrl: '/static/partials/configuration/mix_design_popover.html',
                transclude: true,
                replace: true,
                controller: ['$scope', function ($scope) {

                }],
                // replace: true,
                link: function ($scope, $element, $attr) { //, pdMixDesignConfigurator) {
                    // $scope.selectObject = pdMixDesignConfigurator.selectObject;
                }
            };
        }])

        .directive('pdProductionModePopover', ['$rootScope', 'MixDesignSvc', 'MaterialSvc', function ($rootScope, MixDesignSvc, MaterialSvc) {
            return {
                // require: "^pdMixDesignConfigurator",
                restrict: "E",
                replace: true,
                templateUrl: '/static/partials/configuration/production_mode_popover.html',
                transclude: true,
                controller: ["$scope", function ($scope) {


                    $scope.popoverTitle = "Output materials";
                }],
                // replace: true,
                link: function ($scope, $element, $attr) { //, pdMixDesignConfigurator) {
                    // $scope.selectObject = pdMixDesignConfigurator.selectObject;
                }
            };
        }])

})();
